var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('button',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"float-link",on:{"click":_vm.handleWhatsappButtonClick}},[_c('v-img',{attrs:{"src":require('@/images/whatsapp.png')}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }